export default {
    'logout': 'Вы вышли из системы',
    'auth/user-not-found': 'Пользователя с такими данными не существует',
    'auth/wrong-password': 'Пользователя с такими данными не существует',
    'auth/email-already-in-use': 'Пользователь с таким email уже существует',
    'signin': 'Сначала зайдите в систему',
}